import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { map } from 'rxjs';

import {
  CustomerService,
  RouterService,
  SRouterLinkWithHrefDirective,
  TranslateDirective,
  TranslatePipe,
  isObjectEmpty,
} from '@speedy/core';
import { AsyncPipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-customer-menu',
  templateUrl: './customer-menu.component.html',
  styleUrls: ['./customer-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    MatButton,
    MatMenuTrigger,
    MatIcon,
    TranslateDirective,
    MatMenu,
    SRouterLinkWithHrefDirective,
    MatMenuItem,
    AsyncPipe,
    TranslatePipe,
  ],
})
export class CustomerMenuComponent {
  @Output() childEvent = new EventEmitter();

  customer$ = this.customerService.subscribeToCustomer();

  isCustomerPresent$ = this.customer$.pipe(map((v) => !isObjectEmpty(v)));

  constructor(
    private customerService: CustomerService,
    private routerService: RouterService,
  ) {}

  logout() {
    return this.customerService.clearSession().subscribe(() => {
      this.routerService.navigate('auth/logout');
    });
  }

  toggleMenu() {
    this.childEvent.emit();
  }
}
